import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Title from '../../../components/Title';

const useStyles = makeStyles(theme => ({
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  title: {
    display: 'block',
    marginBottom: theme.spacing(1),
    textTransform: 'uppercase',
  },
}));

const PerformanceTypeInfoBlock = ({ title, children }) => {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <Title className={classes.title}>{title}</Title>
      {children}
    </div>
  );
};

PerformanceTypeInfoBlock.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default PerformanceTypeInfoBlock;
